<template>
  <div class="express">
    <div class="express_nav">
      <div class="express_top">
        <div class="express_left">
          <div class="express_title">
           <!-- <div class="express_xian" v-if="title[0].zt"></div> -->
            <div class="express_txt" @click="dian(title[0].zt,title[0].id)" :class="title[0].zt?'addtxt':''">
              <div style="width: auto;display: inline-block;padding-bottom: 13px;" :class="title[0].zt?'xian':''">{{title[0].txt}}</div>
              <span class="express_txt2">{{title[0].txt2}}</span>
             <div class="express_xian2"></div>
            </div>
            <div class="express_list" v-for="(item,index) in title" :key="index" v-if="index>0 && index<5" @click="dian(item.zt,item.id)" :class="item.zt?'addtxt':''">
              <div style="width: auto;display: inline-block;padding-bottom: 13px;" :class="item.zt?'xian':''">{{item.txt}}</div>
              <div class="express_xian2" v-if="item.id!=title.length"></div>
            </div>
            <div class="express_more" @click="jumpduo()">
              <div class="zi">MORE></div>
            </div>
          </div>
          <div class="express_nav2" v-if="num==1">
            <div class="express_nav2l">
              <img :src="list.titlePhoto" alt="">
              <div class="express_btn">精彩回眸</div>
            </div>
            <div class="express_nav2r">
              <div class="express_list2" v-for="(item,index) in list.issueInfoList" :key="index" v-if="index<4" @click="jump(item.year,item.issue,item.id)">
                <div class="express_dian" :class="item.zt?'add2':''" @mouseover="addtop(1,item.id)" @mouseout="addtop(2,item.id)"></div>
                <div class="express_wen" @mouseover="addtop(1,item.id)" @mouseout="addtop(2,item.id)">
                  <div class="wen1" :class="item.zt?'add1':''" @mouseover="addtop(1,item.id)" @mouseout="addtop(2,item.id)">{{item.title}}</div>
                  <div class="wen2">{{item.channelName}}</div>
                </div>
                <div class="zhai">
                  <div class="wen3">{{item.yearVolumeIssue}}</div>
                  <div style="width: 50%;float: left;">
                    <div style="float: right;">
                      <div class="zhai_right" @click.stop="down(item.id)">下载</div>
                      <div class="zhai_left">摘要</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="guokan" v-if="num==2">
            <div class="guokan_nav" v-for="(item,index) in guokan" :key="index">
              <div class="guokan_left">{{item.year}}</div>
              <div class="guokan_right">
                <ul>
                	<li v-for="(item2,index2) in item.issueLists" :key="index2" @click="jumpqi(item.year,item2.issue)">第{{item2.issue}}期</li>
                </ul>
              </div>
              <div class="guokan_dian"></div>

            </div>
          </div>
          <div class="express_nav2" v-if="num==3">
            <div class="express_nav2l">
              <img src="/src/assets/tu4.png" alt="">
              <div class="express_btn">精彩回眸</div>
            </div>
            <div class="express_nav2r">
              <div class="express_list2" v-for="(item,index) in xia" :key="index" v-if="index<8" @click="jump(item.year,item.issue,item.id)">
                <div class="express_dian" :class="item.zt?'add2':''" @mouseover="addtop3(1,item.id)" @mouseout="addtop3(2,item.id)"></div>
                <div class="express_wen" @mouseover="addtop3(1,item.id)" @mouseout="addtop3(2,item.id)" style="overflow: hidden;width: 94%;">
                  <div class="wen1" :class="item.zt?'add1':''" style="float: left;"><span class="span3" :class="item.zt?'add1':''">{{item.title}}</span><span style="width: 16%;float: right;text-align: right;">({{item.downloads}})</span></div>
                </div>
              </div>
            </div>
          </div>
          <div class="express_nav2" v-if="num==4">
            <div class="express_nav2l">
              <img src="/src/assets/tu4.png" alt="">
              <div class="express_btn">精彩回眸</div>
            </div>
            <div class="express_nav2r">
              <div class="express_list2" v-for="(item,index) in liu" :key="index" v-if="index<8" @click="jump(item.year,item.issue,item.id)">
                <div class="express_dian" :class="item.zt?'add2':''" @mouseover="addtop4(1,item.id)" @mouseout="addtop4(2,item.id)"></div>
                <div class="express_wen" @mouseover="addtop4(1,item.id)" @mouseout="addtop4(2,item.id)" style="overflow: hidden;width: 94%;">
                  <div class="wen1" :class="item.zt?'add1':''" style="float: left;"><span class="span3" :class="item.zt?'add1':''">{{item.title}}</span><span style="width: 16%;float: right;text-align: right;">({{item.hits}})</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="express_right">
          <div class="express_rtitle">
            <div class="waike" style="width: auto;display: inline-block;padding-bottom: 13px;">精彩视频</div>
            <div class="zi" @click="jumpwai">MORE></div>
          </div>
          <div class="express_rxia" @click="jumpwai1">
            <img :src="titlePhoto" alt="" class="express_rimg" @click="jumpspxq(contentId)">
            <div class="express_rtxt" @click="jumpspxq(contentId)">{{title2}}</div>
            <div class="express_rlist" v-for="(item,index) in list2" :key="index" v-if="index<3 && index>0" @mouseover="addtop2(1,index)" @mouseout="addtop2(2,index)" @click="jumpspxq(item.contentId)">
              <div class="express_dian" :class="item.zt?'add2':''"></div>
              <div class="wenben" :class="item.zt?'add1':''">{{item.title}}</div>
            </div>
          </div>
        </div>
      </div>
<!--      <div class="express_bottom">
        <ul>
          <li>
            <img src="/src/assets/gg01.jpg" alt="">
          </li>
          <li>
            <img src="/src/assets/gg02.jpg" alt="">
          </li>
          <li>
            <img src="/src/assets/gg03.jpg" alt="">
          </li>
          <li>
            <img src="/src/assets/gg04.jpg" alt="">
          </li>
        </ul>
      </div> -->
    </div>
  </div>
</template>

<script>

 export default {
  data () {
    return {
      titlePhoto: '',
      contentId: '',
      title2: '',
      guokan: [],//过刊浏览
      title: [
         {
           id: 1,
           txt: '当前目录',
           txt2: '(每月20日出版)'
         },
         {
           id: 2,
           txt: '过刊浏览'
         },
         {
           id: 3,
           txt: '下载排行'
         },
         {
           id: 4,
           txt: '浏览排行'
         },
      ],//导航栏
       list: [],//每期快报
       list2: [
         {
           id: 1,
           txt: '多西他赛对进展期胃癌术后化疗疗效影响向...'
         },
         {
           id: 2,
           txt: '中国腹腔镜减重代谢外科20年研究文献分析...'
         }
       ],//外科天地
       xia: [],//下载排行
       liu: [],//浏览排行
       num: 1,//1:每期快报  2:过刊浏览  3:下载排行  4:浏览排行
    }
  },methods:{
    down(contentId){
      var that = this;
      that.$httphelper.GetContentFilePath({
        "journalId": that.$_JournalId,
        "contentId": contentId,
        "downType": 1
      }).then(res => {
        if(res.code==200){
          window.open(res.data);
          that.$loading.hideLoading();
        }else{
          that.$alert(res.msg, '提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }
      });
    },
    jumpspxq(contentId){
      this.$router.push({path:'/surgery_details',query:{contentId:contentId}});
    },
    //精彩视频
    GetHomePageBlockInfo(){
      var that = this;
      that.$httphelper.GetHomePageBlockInfo({
        "pChannelId": 0,
        "channelId": 2816,
        "jChannelID": 0,
        "dataSourceType": 2,
        "dataShowType": 1,
        "journalId": that.$_JournalId,
        "curr": 1,
        "limit": 3,
      }).then(res => {
        if(res.code==200){
          that.list2 = res.data || '';
          if(that.list2){
            that.titlePhoto = that.list2[0].titlePhoto;
            that.contentId = that.list2[0].contentId;
            that.title2 = that.list2[0].title;
          }
          that.$loading.hideLoading();
        }else{
          that.$alert(res.msg, '提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }
      });
    },
    //每期快报 获取当期 期刊信息
    GetCurrentPeriod() {
      var that = this;
      that.$httphelper.GetCurrentPeriod({
        "journalId": that.$_JournalId,
        "year": 2020
      }).then(res => {
        if(res.code==200){
          that.list = res.data || '';
          console.log(that.list,'期刊！！！')
          that.$loading.hideLoading();
        }else{
          that.$alert(res.msg, '提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }
      });
    },
    //过刊浏览目录
    GetYearVolumeTree() {
      var that = this;
      that.$httphelper.GetYearVolumeTree({
        "journalId": that.$_JournalId,
      }).then(res => {
        if(res.code==200){
          that.guokan = res.data || '';
          that.$loading.hideLoading();
        }else{
          that.$alert(res.msg, '提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }
      });
    },
    //获取首页期刊 排行类型 分页列表数据
    GetJournalArticleList(id){
      var that = this;
      that.$httphelper.GetJournalArticleList({
        "journalId": that.$_JournalId,
        "queryType": id,
        "curr": 1,
        "limit": 8
      }).then(res => {
        if(res.code==200){
          if(id==2){
            that.xia = res.data || '';
          }else{
            that.liu = res.data || '';
          }
          that.$loading.hideLoading();
        }else{
          that.$alert(res.msg, '提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }
      });
    },
    //初始化页面
    index(){
      this.$loading.showLoading();
      //每期快报 获取当期 期刊信息
      this.GetCurrentPeriod();
      //精彩视频
      this.GetHomePageBlockInfo();
      for(var i=0;i<this.title.length;i++){
        if(i==0){
          this.title[i].zt = true;
          this.title.push('1');
          this.title.pop('1');
        }else{
          this.title[i].zt = false;
          this.title.push('1');
          this.title.pop('1');
        }
      }
      for(var i=0;i<this.list.length;i++){
        this.list[i].zt = false;
        this.list.push('1');
        this.list.pop('1');
      }
      for(var i=0;i<this.list2.length;i++){
        this.list2[i].zt = false;
        this.list2.push('1');
        this.list2.pop('1');
      }
      for(var i=0;i<this.xia.length;i++){
        this.xia[i].zt = false;
        this.xia.push('1');
        this.xia.pop('1');
      }
      for(var i=0;i<this.liu.length;i++){
        this.liu[i].zt = false;
        this.liu.push('1');
        this.liu.pop('1');
      }
    },
    //标题点击事件
    dian(zt,id){
      this.num = id;
      if(this.num==1){
        //每期快报 获取当期 期刊信息
        this.GetCurrentPeriod();
      }else if(this.num==2){
        //获取过刊目录列表
        this.GetYearVolumeTree();
      }else if(this.num==3){
        //下载排行
        this.GetJournalArticleList(2);
      }else if(this.num==4){
        //浏览排行
        this.GetJournalArticleList(1);
      }
      if(!zt){
        for(var i=0;i<this.title.length;i++){
          if(id==this.title[i].id){
            this.title[i].zt = true;
            this.title.push('1');
            this.title.pop('1');
          }else{
            this.title[i].zt = false;
            this.title.push('1');
            this.title.pop('1');
          }
        }
      }
    },
     //每期快报鼠标悬停
     addtop(num,id){
       if(num==1){
         for(var i=0;i<this.list.issueInfoList.length;i++){
           if(id==this.list.issueInfoList[i].id){
             this.list.issueInfoList[i].zt = true;
             this.list.issueInfoList.push('1');
             this.list.issueInfoList.pop('1');
           }
         }
       }else{
         for(var i=0;i<this.list.issueInfoList.length;i++){
           this.list.issueInfoList[i].zt = false;
           this.list.issueInfoList.push('1');
           this.list.issueInfoList.pop('1');
         }
       }
     },
     //下载排行鼠标悬停
     addtop3(num,id){
       if(num==1){
         for(var i=0;i<this.xia.length;i++){
           if(id==this.xia[i].id){
             this.xia[i].zt = true;
             this.xia.push('1');
             this.xia.pop('1');
           }
         }
       }else{
         for(var i=0;i<this.xia.length;i++){
           this.xia[i].zt = false;
           this.xia.push('1');
           this.xia.pop('1');
         }
       }
     },
     //浏览排行鼠标悬停
     addtop4(num,id){
       if(num==1){
         for(var i=0;i<this.liu.length;i++){
           if(id==this.liu[i].id){
             this.liu[i].zt = true;
             this.liu.push('1');
             this.liu.pop('1');
           }
         }
       }else{
         for(var i=0;i<this.liu.length;i++){
           this.liu[i].zt = false;
           this.liu.push('1');
           this.liu.pop('1');
         }
       }
     },
     //外科天地鼠标悬停
     addtop2(num,id){
       if(num==1){
         for(var i=0;i<this.list2.length;i++){
           if(id==i){
             this.list2[i].zt = true;
             this.list2.push('1');
             this.list2.pop('1');
           }
         }
       }else{
         for(var i=0;i<this.list2.length;i++){
           this.list2[i].zt = false;
           this.list2.push('1');
           this.list2.pop('1');
         }
       }
     },
     jumpduo(){
       if(this.num==1){
        this.$router.push({path:'/browse'});
       }else if(this.num==2){
        this.$router.push({path:'/browse'});
       }else if(this.num==3){
        this.$router.push({path:'/download_details',query:{titlename:'下载排行'}});
       }else if(this.num==4){
        this.$router.push({path:'/download_details',query:{titlename:'浏览排行'}});
       }
     },
     jump1(){
       this.$router.push({path:'/browse'});
     },
     jump(year,issue,issuecid){
        this.$router.push({path:'/browse_details',query:{year:year,issue:issue,issuecid:issuecid}});
     },
     jumpwai(){
       this.$router.push({path:'/surgery'});
     },
     jumpwai1(){
       this.$router.push({path:'/surgery_details'});
     },
     jumpqi(year,issue){
       this.$router.push({path:'/browse',query:{year:year,issue:issue}});
     }
  },
  created(){
    this.index();
  }
}
</script>

<style lang="scss" scoped>
.express{
    width: 100%;
    min-width: 1366px;
    background-color: #FFFFFF;
    padding-top: 38px;
    .express_nav{
      width: 85%;
      margin: 0 auto;
      .express_top{
        width: 100%;
        overflow: hidden;
        .express_left{
          width: 77%;
          float: left;
          background-color: #FFFFFF;
          padding-bottom: 39px;
          .express_title{
            width: 95%;
            margin: 0 auto;
            height: 36px;
            border-bottom: 3px solid #DBDBDB;
            position: relative;
            padding-top: 31px;
            .express_xian{
              width: 79px;
              height: 3px;
              background-color: var(--biao);
              position: absolute;
              left: 0;
              bottom: 0;
            }
            .express_txt{
              width: 23%;
              float: left;
              font-size: 20px;
              font-family: Source Han Sans SC;
              cursor: pointer;
              font-weight: 400;
              color: #000000;
              line-height: 23px;
              position: relative;
              padding-bottom: 11px;
              .express_txt2{
                color: #949494;
                font-size: 14px;
                font-family: Source Han Sans SC;
                line-height: 23px;
                margin-left: 20px;
              }
              .express_xian2{
                width: 2px;
                height: 16px;
                background: #EEEEEE;
                position: absolute;
                right: 0;
                top: 7px;
              }
            }
            .express_list{
              width: 15%;
              float: left;
              cursor: pointer;
              font-size: 18px;
              font-family: Source Han Sans SC;
              font-weight: 400;
              color: #000000;
              line-height: 23px;
              position: relative;
              text-align: center;
              .express_xian2{
                width: 2px;
                height: 16px;
                background: #EEEEEE;
                position: absolute;
                right: 0;
                top: 7px;
              }
              .express_xian3{
                width: 100%;
                height: 3px;
                background: var(--biao);
                position: absolute;
                bottom: -16px;
                left: 0;
              }
            }
            .express_more{
            	float: right;
            	width: 90px;
            	height: 12px;
            	font-size: 14px;
            	font-family: Source Han Sans SC;
            	font-weight: bold;
            	color: #878787;
            	line-height: 23px;
              cursor: pointer;
              .zi{
                font-size: 14px;
                font-family: Source Han Sans SC;
                font-weight: bold;
                color: #878787;
                line-height: 23px;
                text-align: right;
              }
            }
          }
          .express_nav2{
            width: 95%;
            margin: 0 auto;
            overflow: hidden;
            margin-top: 20px;
            .express_nav2l{
              width: 23%;
              float: left;
              img{
                width: 207px;
                height: 281px;
                object-fit: cover;
                cursor: pointer;
              }
              img:hover{
                transform: scale(1.05);
              }
              .express_btn{
                width: 163px;
                margin-left: 23px;
                text-align: center;
                line-height: 42px;
                height: 42px;
                background: var(--btn);
                border-radius: 12px;
                margin-top: 22px;
                color: #FFFFFF;
                cursor: pointer;
              }
            }
            .express_nav2r{
              width: 77%;
              float: left;
              overflow: hidden;
              .express_list2{
                width: 100%;
                overflow: hidden;
                cursor: pointer;
                margin-bottom: 12.3px;
                .express_dian{
                  width: 10px;
                  height: 10px;
                  background: #DBDBDB;
                  border-radius: 50%;
                  margin-right: 21px;
                  float: left;
                  margin-top: 6px;
                }
                .express_wen{
                  width: 80%;
                  float: left;
                  .wen1{
                    width: 100%;
                    font-size: 16px;
                    font-family: Adobe Heiti Std;
                    font-weight: normal;
                    color: #000000;
                    margin-bottom: 12.2px;
                    .span3{
                      width: 83%;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                      overflow:hidden;
                      float: left;
                    }
                  }
                  .wen2{
                    width: 100%;
                    font-size: 14px;
                    font-family: Adobe Heiti Std;
                    font-weight: normal;
                    color: #636363;
                    margin-bottom: 10px;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow:hidden;
                  }
                }
                .zhai{
                  width: 95%;
                  padding-left: 31px;
                  overflow: hidden;
                  float: left;
                  .wen3{
                    width: 50%;
                    font-size: 14px;
                    font-family: Adobe Heiti Std;
                    font-weight: normal;
                    color: #636363;
                    float: left;
                  }
                  .zhai_left,.zhai_right{
                    font-size: 14px;
                    font-family: Adobe Heiti Std;
                    font-weight: normal;
                    color: #000000;
                    float: right;
                  }
                  .zhai_right{
                    margin-left: 30px;
                  }
                  .zhai_left:hover{
                    text-decoration: underline;
                    color: var(--biao);
                  }
                  .zhai_right:hover{
                    text-decoration: underline;
                    color: var(--biao);
                  }
                }
              }
              .express_list2:last-child{
                margin-bottom: 0;
              }
            }
          }
          .guokan{
            width: 90%;
            margin: 0 auto;
            margin-top: 21px;
            height: 350px;
            overflow-y: auto;
            .guokan_nav{
              width: 100%;
              overflow: hidden;
              position: relative;
              .guokan_dian{
                width: 11px;
                height: 11px;
                border: 1px solid var(--biao);
                border-radius: 50%;
                position: absolute;
                top: 0;
                left: 54px;
                background-color: var(--biao);
              }
              .guokan_left{
                width: 60px;
                float: left;
              }
              .guokan_right{
                width: 91%;
                float: left;
                ul{
                  list-style: none;
                  width: 100%;
                  overflow: hidden;
                  margin-top: 0;
                  border-left: 1px solid var(--biao);
                  margin-bottom: 0;
                  padding-bottom: 8px;
                  li{
                    width: 12%;
                    margin-right: 4%;
                    float: left;
                    border: 1px solid #7D7D7D;
                    text-align: center;
                    font-size: 16px;
                    font-family: Adobe Heiti Std;
                    font-weight: normal;
                    color: #7D7D7D;
                    line-height: 24px;
                    margin-bottom: 24px;
                    cursor: pointer;
                  }
                  li:hover{
                    color: var(--biao);
                    border: 1px solid var(--biao);
                  }
                  li:last-child{
                    margin-right: 0;
                  }
                }
              }
            }
          }
        }
        .express_right{
          width: 23%;
          float: right;
          padding-top: 30px;
          background-color: #FFFFFF;
          padding-bottom: 15px;
          .express_rtitle{
            width: 90%;
            margin: 0 auto;
            overflow: hidden;
            border-bottom: 3px solid #DBDBDB;
            position: relative;
            .waike{
              width: 50%;
              float: left;
              font-size: 20px;
              font-family: Source Han Sans SC;
              font-weight: bold;
              color: #000000;
              line-height: 23px;
              border-bottom: 3px solid var(--xt);
            }
            .zi{
              width: 50%;
              float: right;
              text-align: right;
              font-size: 14px;
              font-family: Source Han Sans SC;
              font-weight: bold;
              color: #878787;
              line-height: 23px;
              cursor: pointer;
            }
            .waixian{
              position: absolute;
              bottom: 0;
              left: 0;
              width: 81px;
              height: 3px;
              background: var(--biao);
            }
          }
          .express_rxia{
            width: 90%;
            margin: 0 auto;
            .express_rimg{
              width: 100%;
              height: 199px;
              margin-top: 25px;
              margin-bottom: 30px;
              cursor: pointer;
            }
            .express_rimg:hover{
              transform: scale(1.05);
            }
            .express_rtxt{
              font-size: 18px;
              font-family: Adobe Heiti Std;
              font-weight: bold;
              color: #000000;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow:hidden;
              cursor: pointer;
            }
            .express_rlist{
              width: 100%;
              overflow: hidden;
              margin-top: 30px;
              margin-bottom: 21px;
              cursor: pointer;
              .express_dian{
                width: 10px;
                height: 10px;
                background: #DBDBDB;
                border-radius: 50%;
                margin-right: 15px;
                float: left;
                margin-top: 6px;
              }
              .wenben{
                width: 85%;
                float: left;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow:hidden;
                font-size: 16px;
                font-family: Adobe Heiti Std;
                font-weight: normal;
                color: #000000;
              }
            }
          }
        }
      }
      .express_bottom{
        width: 100%;
        overflow: hidden;
        margin-top: 19.5px;
        padding-bottom: 40px;
        ul{
          width: 100%;
          list-style: none;
          overflow: hidden;
          padding-left: 0;
          li{
            width: 24%;
            margin-right: 1.33%;
            float: left;
            cursor: pointer;
            img{
              width: 100%;
              height: 120px;
            }
            img:hover{
              transform: scale(1.05);
            }
          }
          li:last-child{
            margin-right: 0;
          }
        }
      }
    }
}


@media only screen and (min-width: 1200px) {
  .express_txt{
    width: 27%!important;
  }
  .express_nav2l{
    img{
      width: 180px!important;
    }
    .express_btn{
      margin-left: 7px!important;
    }
  }
}

.add1{
  color: var(--xt)!important;
  text-decoration: underline!important;
}
.add2{
  background-color: var(--xt)!important;
}
.addtxt{
  font-weight: bold!important;
  font-size: 20px!important;
}
.xian{
  border-bottom: 3px solid var(--xt)!important;
}
</style>



// WEBPACK FOOTER //
// src/components/public/home/express.vue